import { Fragment } from "react"

/** Renders "Guide · Barbers" with tighter spacing around the middle dot. */
export function JournalCategoryLabel({
  label,
  className,
  style,
}: {
  label: string
  className?: string
  style?: React.CSSProperties
}) {
  const parts = label.split(" · ")
  if (parts.length === 1) {
    return (
      <span className={className} style={style}>
        {label}
      </span>
    )
  }

  return (
    <span className={`inline-flex items-center gap-1 ${className ?? ""}`} style={style}>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 ? (
            <span aria-hidden style={{ opacity: 0.55 }}>
              ·
            </span>
          ) : null}
          <span>{part}</span>
        </Fragment>
      ))}
    </span>
  )
}
